import { render, staticRenderFns } from "./MobilePianificaMenu.vue?vue&type=template&id=40a9b40e&scoped=true&"
import script from "./MobilePianificaMenu.vue?vue&type=script&lang=js&"
export * from "./MobilePianificaMenu.vue?vue&type=script&lang=js&"
import style0 from "./MobilePianificaMenu.vue?vue&type=style&index=0&id=40a9b40e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a9b40e",
  null
  
)

export default component.exports